import { Button } from "@mui/material";
import React from "react";

const ServiceBtn = ({
  quickEnquiryText = "Quick Enquiry",
  seeOurWorkText = "See Our Work",
  onQuickEnquiry,
  onSeeOurWork,
}) => {
  return (
    <div
      style={{ marginTop: "20px" }}
    >
      <Button
        sx={{ padding: "10px 30px" }}
        variant="contained"
        color="primary"
        onClick={onQuickEnquiry}
      >
        {quickEnquiryText}
      </Button>
      <Button
        sx={{ marginLeft: "20px", padding: "10px 30px" }}
        variant="outlined"
        color="primary"
        onClick={onSeeOurWork}
      >
        {seeOurWorkText}
      </Button>
    </div>
  );
};

export default ServiceBtn;
